const Path = {
  '/desabonnement': '/Unsubscribe',
  '/unsubscribe': '/Unsubscribe',
  '/inscription': '/Register',
  '/register': '/Register',
  '/modifier-preferences': '/Modify-Preferences',
  '/modify-preferences': '/Modify-Preferences',
  '/confirmation-activation': '/Activation-Confirmation',
  '/activation-confirmation': '/Activation-Confirmation',
  '/activate-account': '/Activate-Account',
  '/activation-compte': '/Activate-Account',
};

const Error = {
  Title: 'You are not connected. Please reconnect to continue.',
};

const ActivateAccount = {
  Title: 'Congratulations!',
  Description:
    "Your profile's basic information has been filled out, and your account is almost ready. Before letting you enjoy your Familiprix account, let's validate your email address. Check your spam if you don’t see the email in your inbox. Once your email is confirmed, we’ll let you personalize your account through three short steps.",
  NotReceived: "Didn't receive the email?",
  SendNewEmail: 'Send a new confirmation email',
  SuccessMessage:
    "We have just sent an email to {{email}} with a link that will allow you toactivate your account. Check your inbox in the next few minutes. If you don't see the email, remember to check your SPAM folder.",
};

const MetaTag = {
  RegisterTitle: 'Register - Familiprix Account',
  RegisterDescription:
    'Create your Familiprix account now and take advantage of our exclusive offers. Sign up in minutes and start shopping online!',
  SettingTitle: 'My Personnal Settings - Familiprix Account',
  SettingDescription:
    'Customize your Familiprix Account settings with My Personal Settings. Update your information in just a few clicks.',
  AddAddressTitle: 'New Address - Familiprix Account',
  AddAddressDescription:
    'Add a new address in no time with the Familiprix account. Make shopping online easier with fast and convenient delivery.',
  EditAddressTitle: 'Modify my address - Familiprix Account',
  EditAddressDescription:
    'Modify your addresses with the Familiprix account. Add new addresses, manage existing ones and make shopping online easier with fast and convenient delivery.',
  ShoppingPrefTitle: 'Shopping Preferences - Familiprix Account',
  ShoppingPrefDescription:
    'Personalize your online shopping experience with the Familiprix account. Personalize your account by adjusting your shopping preferences and more.',
  CommunicationPrefTitle: 'Communications Preferences - Familiprix Account',
  CommunicationPrefDescription:
    'Help us send you relevant content with the Familiprix account. Personalize your account by adjusting your communications preferences and more.',
  FamiliplusTitle: 'Familiplus - Familiprix Account',
  FamiliplusDescription:
    'Enjoy exclusive Familiplus benefits with your Familiprix account. Save on a ton of products, get rewards and more!',
  TransactionTitle: 'Familiplus - All Transactions - Familiprix Account',
  TransactionDescription: 'Consult your Familiplus transaction history and easily track your accumulated points.',
  OESTitle: 'Familiplus - Opération Enfant Soleil - Familiprix Account',
  OESDescription:
    'Use your Familiplus points to donate to Opération Enfant Soleil and help raise funds for sick children.',
  ReplaceCardTitle: 'Familiplus - Change my card - Familiprix Account',
  ReplaceCardDescription:
    'Replace your lost or damaged Familiplus card in just a few clicks using your Familiprix account.',
  FamiliplusCardTitle: 'Familiplus - Become a member - Familiprix Account',
  FamiliplusCardDescription: 'Become a Familiplus member in just a few clicks with your Familiprix account.',
  PreferenceCenterTitle: 'Preference Center - Familiprix',
  PreferenceCenterDescription: 'Manage your preferences easily with our personalized preference center.',
  UnsubscribeTitle: 'Unsubscribe - Familiprix',
  UnsubscribeDescription: 'Quick and easy unsubscribe.',
  ActivationConfirmationTitle: 'Confirmation of your account creation - Familiprix',
  ActivationConfirmationDescription: 'Your account is created. Now take full advantage of your Familiprix account.',
  RedirectTitle: 'Redirect - Familiprix',
  RedirectDescription: 'Your account is created. Please validate your account using the email we sent you.',
  ActivateAccountTitle: 'Activate your account - Familiprix',
  ActivateAccountDescription: 'Activate your registration to take full advantage of your Familiprix account.',
};

const FooterLinkTitle = {
  FAQ: 'FAQ',
  ContactUs: 'Contact us',
  FindAPharmacy: 'Find a pharmacy',
  Privacy: 'Privacy Policy',
  OnlinePurchase: 'Online Purchase Policy',
  TermsAndConditions: 'Terms and Conditions',
  GeneralTermsService: 'Terms of Service',
};

const Buttons = {
  Next: 'Next',
  Previous: 'Previous',
  Skip: 'Skip',
  Cancel: 'Cancel',
  Confirm: 'Confirm',
  Return: 'Back',
  Create: 'Create',
  Add: 'Add',
  Save: 'Save',
};

const LegalTitle = {
  Rights: 'All rights reserved. © Familiprix',
  Terms: 'Terms of Use',
  PersonalPolicy: 'Personal Information Policy',
  ReadAndAgree: `I've read and agree to`,
  PrivacyPolicy: 'Privacy Policy',
  Age: 'I declare that I am 14 years or older',
  Data: 'Familiprix uses my data for personalization purposes (optional)',
};

const Prepositions = {
  TheS: 'the',
  TheM: 'the',
  TheF: 'the',
  AndThe: 'and the',
  And: 'and',
  Our: 'our',
  That: 'that',
  Your: 'your',
  A: 'a',
};

const NavBar = {
  NavTitle: 'Create an account',
  NavDescription: 'Please complete the steps to create your account',
};

const NavBarStepperLabel = {
  Informations: 'Informations',
};

const NavBarConnection = {
  ConnectionQuestion: 'Already have an account?',
  ConnectionLink: 'Log in',
};

const Form = {
  Optional: '(optional)',
  Email: 'Email',
  Password: 'Password',
  Confirmation: 'Confirm password',
  FirstName: 'First name',
  LastName: 'Last name',
  PhoneNumber: 'Phone number',
  MobileNumber: 'Mobile number',
  PhoneNumberMessage: 'Please enter at least one phone number',
  AddressLabel: 'Address name',
  CivicNumber: 'Civic number',
  Street: 'Street',
  Select: 'Select',
  Apartment: 'Apartment',
  City: 'City',
  Province: 'Province',
  PostalCode: 'Postal code',
  Country: 'Country',
  InvoicePreference: 'Receipt preferences',
  GenderPreference: 'Gender',
  Birthday: 'Date of birth',
  Birthyear: 'Year of birth',
  CardNumber: 'Card number',
};

const FormValidations = {
  ValidEmail: 'valid email',
  ValidPwd: 'valid password',
  ValidCardNumber: 'valid card number',
  ValidPhoneNumber: 'valid phone number',
  AssiciatedWithAddress: 'associated with the address',
  PleaseEnter: 'Please enter',
  PleaseConfirm: 'Please confirm',
  Required: 'The field {{field}} is required',
  RequiredOnePhone: 'Please enter at least one phone number',
  InvalidFormat: 'The {{field}} format is invalid',
  InvalidField: 'Invalid {{field}}',
  FieldTooShort: 'The field {{field}} must be at least {{length}} characters',
  FieldTooLong: 'The field {{field}} must not be over {{length}} characters',
  FieldIncorrectLength: 'The field {{field}} must have {{length}} characters',
  PasswordMustMatch: 'Password not identical',
  PrivacyPolicyRequired: 'Please read and accept the Terms of Use and the Privacy Policy',
  AgeConsentRequired: 'Please confirm that you are 14 years of age or older',
  InvalidBirthday: 'Please enter a valid date of birth',
  MissingBirthyear: 'Please enter a year of birth',
  TermsAndConditionRequired: 'Please read and accept the Terms and Conditions of the Familiplus program',
  passwordLength: 'At least 8 characters',
  passwordCharTypes: 'At least 3 of these 4 types of characters:',
  passwordLowercase: 'Lower case (a-z)',
  passwordUppercase: 'Upper case (A-Z)',
  passwordNumber: 'Numbers (0-9)',
  passwordSpecialChar: 'Special characters (!@#$%?&*)',
  passwordIdenticalChars: 'No more than 2 identical characters in a row (example : "aaa" is not permitted)',
  InvalidName:
    'The {{field}} field contains invalid characters. Please correct and resubmit.\r\nOnly the following characters are accepted: Letters and numbers with or without accents (a-z, A-Z, 0-9), spaces, dashes ( - ) and periods ( . ).',
};

const Province = {
  AB: 'Alberta',
  BC: 'British Columbia',
  MB: 'Manitoba',
  NB: 'New Brunswick',
  NL: 'Newfoundland and Labrador',
  NT: 'Northwest Territories',
  NS: 'Nova Scotia',
  NU: 'Nunavut',
  ON: 'Ontario',
  PE: 'Prince Edward Island',
  QC: 'Quebec',
  SK: 'Saskatchewan',
  YT: 'Yukon',
};

const Position = {
  1: '(1st)',
  2: '(2nd)',
  3: '(3rd)',
  4: '(4th)',
  5: '(5th)',
};

const InvoicePreference = {
  Paper: 'Paper only',
  Email: 'Email only',
  Both: 'Email and paper',
};

const GenderPreference = {
  Female: 'Female',
  Male: 'Male',
  Other: 'Gender neutral',
};

const AuthenticationForm = {
  Title: 'Identification',
};

const AddressForm = {
  EditAddressTitle: 'Edit an address',
  CreateAddressTitle: 'Add an address',
  GetAddressError: `An error occurred while retrieving the address. Please try again in a few minutes.`,
  AddressNotFound: `The requested address does not exist.`,
};

const ShoppingPreferencesForm = {
  Title: 'Shopping preferences',
};

const Languages = {
  ChangeTo: 'Français',
  fr: 'French',
  en: 'English',
};

const BecomeAFamiliplusMember = {
  DontHaveACard: "Don't have a card?",
  CreateOneHere: 'Create one here.',
  CreateCard: 'Create a card',
  Title: 'Create your Familiplus card',
  SubTitle: 'Desired card type',
  VirtualCard: 'Virtual card',
  PhysicalCard: 'Physical card',
  IRead: 'I have read and accept the',
  TermsAndConditions: 'Terms and Conditions of the Familiplus program',
  Mandatory: '(Mandatory)',
  PhysicalCardInfo:
    'No plastic cards will be issued online. To obtain a physical card, please visit a Familiprix location near you.',
};

const FamiliplusAdvantages = {
  Title: "It's a big plus",
  Info: 'Earn points on nearly every purchase and earn reward dollars fast. Create or complete your profile in minutes!',
  MemberPrice: 'Save with our Member prices',
  BirthdayGift: 'Receive a gift on your birthday',
  PersonalizedOffers: 'Get personalized offers',
  FamiliplusMobile: 'Earn points in the Familiplus mobile app',
  ExclusiveContests: 'Take advantage of exclusive contests',
  HealthyLife: 'Move and save with Healthy Living',
};

const RegisterFamiliplusCard = {
  Title: 'Become a Familiplus member',
  AltTitle: 'Familiplus membership',
  SubTitle: 'Already have a card? Enter the following information and then proceed to the next step to activate it.',
  CardNumber: 'Your card number',
  AssociatedCardPhone: 'Phone number associated with the card',
  WarningPhoneNumber:
    'Your Familiprix profile is not associated with a phone number. Before linking an existing card to your profile or becoming a Familiplus member, please go to Account Settings and add it. Thank you for your understanding.',
};

const CommunicationPreferences = {
  Title: 'Communication preferences',
  CommunicationLanguageTitle: 'Communication language',
  newsletterConsentTitle: 'Newsletter',
  newsletterConsentLabel:
    'I agree to receive emails from Familiprix Inc. and/or its affiliated members. I understand that I can unsubscribe at any time.',
  NewsletterContentTitle: 'Content of newsletters',
  OffersandpromotionsLabelInfo:
    'Get personalized promotions and be the first to know about contests and new products offered at Familiprix.',
  HealthLabelInfo:
    'Get health advice, based on your interests. You will also be notified about new features on our mobile applications and enjoy the benefits of connecting your health to Familiprix.',
  SmsConsentLabelInfo:
    'By checking this box, I accept receiving SMS messages from Familiprix. The frequency of messages varies. Text HELP to get help and Text STOP or uncheck this box in your Familiprix account to unsubscribe. Message and data rates may apply. Leaving this box unchecked will not enable SMS messages at this time.',
  ClickToView: 'Click to view our',
  personalizationTitle: 'Personalization',
  PersonalizationLabelInfo:
    'I agree to receive personalized communications based on my preferences, browsing behavior and purchase history.',
  Interests: 'Interests',
  SubmitButton: 'Finish',
};

const Errors = {
  ProfileExists: 'The email {{email}} is already associated with a Familiprix account. ',
  MissingEmail:
    'No email address was found in the request, try to log in again and if the problem persists, please contact our customer service at experienceclient@familiprix.com.',
  GetProfileError:
    'There was a problem obtaining your account information. Please try again in a few minutes. If the problem persists, please contact our customer service at experienceclient@familiprix.com.',
  ConnectHere: 'Click here to login.',
  CreateAccountServerError:
    'An error occured while creating your account. Please try again in a few minutes. If the problem persists, please contact our customer service at experienceclient@familiprix.com.',
  Associate404: 'Unable to find your card. Please make sure the information you entered are correct.',
  AlreadyAssociated: 'This card is already associated with a Familiprix account.',
  Associate401:
    'An error has occurred. If the problem persists, please contact our customer service at experienceclient@familiprix.com.',
  GenericError:
    'An error has occurred. Wait a few minutes and try again. If the problem persists, please contact our customer service at experienceclient@familiprix.com.',
};

const Steps = {
  1: 'Identification',
  2: '<logo /> registration',
  3: 'Shopping preferences',
  4: 'Communication preferences',
};

const RegisterConfirmation = {
  authTitle: 'Congratulations! You have successfully created your Familiprix account.',
  familiplusTitle: 'Congratulations!<br /> You have just become a Familiplus member.',
  finalTitle: 'Your profile has been personalized!',
  info: 'Please complete the next steps for a more personalized experience:',
  finalInfo: 'You will be redirected to your Familiprix account in a few seconds.',
  NextStep: 'Next',
};

const ActivationConfirmation = {
  congratulation: 'Congratulation!',
  message: 'Your Familiprix account is now active.',
  finalInfo: 'You can now authenticate yourself. You will shortly be redirected to ',
};

const ReplaceFamiliplusCard = {
  Title: 'Replace my card',
  Info: 'By replacing your number, your old card will no longer work and your balance will be transferred to the new account.',
  CardNumber: 'New number located on the back of the card',
  Button: 'Replace my card',
  Success: 'Your card has been replaced. The card now linked to your Familiplus account is the {{cardNumber}}.',
};

const AccountProfile = {
  Title: 'Account',
  PersonalInfoSection: 'My information',
  SecuritySection: 'Login & Security',
  PasswordChangeButton: 'Change password',
  PasswordChangeSuccessMessage:
    "We have just sent an email to {{email}} with a link that will allow you to change your password. Check your inbox in the next few minutes. If you don't see the email, remember to check your SPAM folder.",
  SubmitButton: 'Save',
  fetchDataFailed: 'An error occurred while recovering your account. Please try again in a few minutes.',
  saveSuccess: 'Your informations have been saved',
  MfaLabel: 'Validation code',
  MfaDescription:
    'Email is used by default for verification. Add SMS or biometrics as additional modes to strengthen security.',
  MfaSmsLabel: 'SMS',
  MfaActive: 'Active',
  MfaInactive: 'Inactive',
  MfaResetButton: 'Reset',
  MfaDisableConfirmTitle: 'Do you want to disable your SMS validation code?',
  MfaDisableConfirmButton: 'Confirm',
  MfaDisableCancelButton: 'Cancel',
  MfaResetSuccess:
    'The SMS authentication factor associated with your account has been reset. During your next login, you will be asked to set it up again to protect your account.',
};

const Preferences = {
  Title: 'My preferences',
  ShoppingTab: 'Shopping',
  CommunicationsTab: 'Communications',
  FetchDataFailed:
    'An error occurred while retrieving your preferences. Please try again in a few minutes. If the problem persists, please contact our customer service at experienceclient@familiprix.com.',
  SaveSuccess: 'Your preferences have been saved',
  ShoppingDescription: 'Fill in your shopping preferences to benefit from a unique and distinctive purchase experience',
  CommunicationDescription:
    'Fill in your communication preferences and receive content tailored to your interests allowing you to experience the best we have to offer.',
};

const NotFound = {
  Title: 'Page not found',
};

const FamiliplusBonusPoints = {
  Title: 'Familiplus bonus points',
  Description: 'When all shopping preferences are completed',
};

const PreferenceCenter = {
  Title: 'Preference center',
  Description: 'Modify your preferences to always benefit from a tailor-made experience adapted to your interests.',
};

const UnsubscribePage = {
  Title: 'We are sorry to see you leave us!',
  Description1: 'To confirm your unsubscription to ',
  Description2:
    ', click the button below. You will lose access to our personalized promotional offers and exclusive health tips. You will also no longer be able to be notified first about contests and new products offered at Familiprix.',
  PreferenceDescription: 'If you would like to adjust your communication preferences, please click on ',
  Confirm: 'Confirm my unsubscription',
  SeePreferences: 'View my preferences',
  UnsubscribeConfirmation: '{{target}} unsubcription confirmed.',
};

const Components = {
  Path,
  ActivateAccount,
  MetaTag,
  PreferenceCenter,
  Steps,
  FooterLinkTitle,
  Buttons,
  InvoicePreference,
  GenderPreference,
  LegalTitle,
  Form,
  FormValidations,
  Prepositions,
  Position,
  AuthenticationForm,
  AddressForm,
  ShoppingPreferencesForm,
  NavBar,
  NavBarStepperLabel,
  NavBarConnection,
  Languages,
  Province,
  BecomeAFamiliplusMember,
  CommunicationPreferences,
  Errors,
  RegisterFamiliplusCard,
  FamiliplusAdvantages,
  RegisterConfirmation,
  ActivationConfirmation,
  ReplaceFamiliplusCard,
  AccountProfile,
  Preferences,
  NotFound,
  FamiliplusBonusPoints,
  UnsubscribePage,
  Error,
};

export default Components;
